const SECTION_SELECTOR = '[data-mox-promo-banner]';
const SECTION_HANDLERS = new WeakMap();

function getActiveIndex(slides) {
  const activeIndex = slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false');
  return activeIndex >= 0 ? activeIndex : 0;
}

function updateProgress(section, index) {
  const fill = section.querySelector('[data-progress-fill]');
  if (!(fill instanceof HTMLElement)) return;
  const slides = Array.from(section.querySelectorAll('slideshow-slide'));
  const total = slides.length || 1;
  const percent = ((index + 1) / total) * 100;
  fill.style.width = `${percent}%`;
}

function mount(section) {
  if (!(section instanceof HTMLElement)) return;
  if (SECTION_HANDLERS.has(section)) return;

  const slideshow = section.querySelector('slideshow-component');
  if (!(slideshow instanceof HTMLElement)) return;

  const slides = Array.from(section.querySelectorAll('slideshow-slide'));
  updateProgress(section, getActiveIndex(slides));

  const onSelect = (event) => {
    const index = event?.detail?.index;
    if (typeof index !== 'number') return;
    updateProgress(section, index);
  };

  slideshow.addEventListener('slideshow:select', onSelect);
  SECTION_HANDLERS.set(section, { slideshow, onSelect });
}

function unmount(section) {
  const entry = SECTION_HANDLERS.get(section);
  if (!entry) return;
  entry.slideshow.removeEventListener('slideshow:select', entry.onSelect);
  SECTION_HANDLERS.delete(section);
}

function mountAll() {
  document.querySelectorAll(SECTION_SELECTOR).forEach((section) => mount(section));
}

mountAll();

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof HTMLElement)) return;
  const section = event.target.querySelector(SECTION_SELECTOR);
  if (section instanceof HTMLElement) mount(section);
});

document.addEventListener('shopify:section:unload', (event) => {
  if (!(event.target instanceof HTMLElement)) return;
  const section = event.target.querySelector(SECTION_SELECTOR);
  if (section instanceof HTMLElement) unmount(section);
});
